import React, { FC } from 'react';
import LoadingSkapa, { LoadingBall } from '@ingka/loading';
import { useTranslation } from 'react-i18next';
import { Layout } from '@pcmp/react-coworker-components';
import Skeleton from '@ingka/skeleton';

const { Container } = Layout;

export const LoadingState: FC<{
  className?: string;
  textI18nKey?: string;
}> = ({ className, textI18nKey = 'label.loading' }) => {
  const { t } = useTranslation();

  return (
    <LoadingSkapa
      data-testid="loading"
      text={t(textI18nKey, { defaultValue: 'Loading...' })}
      className={className}
    >
      <LoadingBall color="emphasised" size="large" />
    </LoadingSkapa>
  );
};

export const LoadingFullScreen: FC<{
  textI18nKey?: string;
}> = ({ textI18nKey }) => (
  <Container className="h-screen flex align-middle justify-center">
    <LoadingState textI18nKey={textI18nKey} />
  </Container>
);

export const LoadingLeftMenu: FC<{
  title?: string;
}> = () => (
  <>
    <Skeleton height="40px" className="my-2" />
    <Skeleton height="40px" className="my-2" />
  </>
);

export const LoadingModal: FC<{
  textI18nKey?: string;
}> = ({ textI18nKey }) => (
  <div className="h-full flex align-middle justify-center">
    <LoadingState textI18nKey={textI18nKey} />
  </div>
);
